import * as React from 'react';
import autobind from 'autobind-decorator';
import { observer } from "mobx-react";
import * as moment from 'moment';
import "moment-timezone";
import { TimePicker, Form } from 'antd';
const FormItem = Form.Item;

export enum DisableKind {
	disableSeconds = 1,
	disableMinutes = 2,
	disableHours = 4,
}

/*
* TimePickerViewProps
*/
interface TimePickerViewProps {
	mode: ControlMode;
	label?: string;
	value?: Date;
	required?: boolean;
	onChanged?: (newValue: Date) => void;
	disableKind?: DisableKind;
	dateUsage?: "utc" | "tz";
}

/**
 * TimePickerView class
 */
@observer
export class TimePickerView extends React.Component<TimePickerViewProps, any> {
	constructor(props) {
		super(props);
		this.state = {
			value: this.parseDate(props.value)
		};
	}

	public componentWillReceiveProps(nextProps: Readonly<TimePickerViewProps>): void {
		if (nextProps.value != this.props.value) {
			this.setState({
				value: this.parseDate(nextProps.value)
			});
		}
	}

	/**
	 * Render
	 */
	public render() {
		let format = '';
		if ((this.props.disableKind & DisableKind.disableHours) != DisableKind.disableHours) {
			format += 'HH';
		}
		if ((this.props.disableKind & DisableKind.disableMinutes) != DisableKind.disableMinutes) {
			format += (format == '' ? '' : ':') + 'mm';
		}
		if ((this.props.disableKind & DisableKind.disableSeconds) != DisableKind.disableSeconds) {
			format += (format == '' ? '' : ':') + 'ss';
		}
		if (format == '') {
			format = undefined;
		}
		return (
			<FormItem
				label={this.props.label}
				required={this.props.required}
			>
				<TimePicker value={this.state.value}
					onChange={this.onChanged}
					disabled={this.props.mode == 'display'}
					format={format}
				/>
			</FormItem>
		);
	}

	private parseDate(value?: any): moment.Moment {
		return value
			? this.props.dateUsage
				? this.props.dateUsage === "tz"
					? moment.tz(value, "Europe/London")
					: moment.utc(value)
				: moment(value)
			: undefined;
	}

	/**
	 * On change value
	 * @param newVal
	 */
	@autobind
	protected onChanged(time: moment.Moment) {
		if (time) {
			time = this.parseDate(time.format().substr(0, 19));
		}
		if (this.props.required && time == null) {
			return;
		}
		this.props.onChanged(time.toDate());
		this.setState({
			value: time
		});
	}
}



// WEBPACK FOOTER //
// ./src/core/ui/timepicker.view.tsx